<template lang="pug">
  v-container(fluid=true class="grey lighten-5 ma-0 pa-0")
    div(class="text-center")
      Heading(:title="$t('forgotPassword.TITLE')")
      Description(:description="$t('forgotPassword.DESCRIPTION')")
      v-flex(class="xs12 sm6 offset-sm3")

        ValidationObserver(ref="form" v-slot="{ validate, dirty }")
          form(@submit.prevent="onSubmit")
            v-layout(column)

              v-flex
                ValidationProvider(name="email" rules="required|email")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined background-color="white"  id="email" name="email" type="email" :label="$t('forgotPassword.EMAIL')" v-model="email" :data-vv-as="$t('forgotPassword.EMAIL')" autocomplete="off" dense)
                    p(class="red--text caption") {{ errors[0] }}

              v-flex(class="text-xs-center mt-5")
                v-btn(:to="{ name: 'login' }" small=true text=true) {{ $t('common.GO_BACK') }}
                SubmitButton(@click="validate().then(submit)" :text="$t('forgotPassword.RECOVER')")

      ErrorMessage
      SuccessMessage
</template>


<script>
import router from '@/router'
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver, localize } from "vee-validate"

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default{
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      email: ''
    }
  },
  methods: {
    ...mapActions(['forgotPassword']),
    async onSubmit() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        await this.forgotPassword({
          email: this.email
        })
      }
    },
    // goBack() {
    //   router.go(-1)
    // }
  },
  created() {
    if (this.$store.state.auth.isTokenSet) {
      router.push({ name: 'home' })
    }
  },
  computed: {
    lang(){
      return this.$store.getters.locale
    }
  },
  watch: {
    lang (newLang) { // se trocou a linguagem, revalida o form
      const lg = { en: en, pt: pt_BR, es: es };
      localize(`${newLang}`, lg[newLang]);
      this.$refs.form.validate();
    }
  }
}
</script>
